module.exports = __webpack_public_path__ + "img/json-icon.c6c5d276.svg";